import React from "react";
import PageHeaderLayout from "../../layout/pageHeaderLayout";
import StandardTable, {StandardColumnsType} from "../../components/StandardTable";
import Moment from "moment";

function OrderList() {

    const columns: StandardColumnsType = [
        {
            title: 'Order Number',
            dataIndex: 'code',
            search: true
        },
        {
            title: 'Customer',
            dataIndex: 'customer',
            search: true
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
        },
        {
            title: 'Qty',
            dataIndex: 'qty'
        },
        {
            title: 'To ERP',
            dataIndex: 'toErp'
        },
        {
            title: 'Create By',
            dataIndex: 'createName',
        },
        {
            title: 'Create Time',
            dataIndex: 'createTime',
            render: (value) => Moment(value).format('lll'),
        },
        {
            title: 'Operations',
            dataIndex: 'operations',
            render: (_, record: any) => (
                <span>

                </span>
            )
        }
    ]

    return (
        <PageHeaderLayout>
            <StandardTable rowKey={'id'} columns={columns}/>
        </PageHeaderLayout>
    )

}

export default OrderList
